module.exports = __webpack_public_path__ + "static/img/Takeuchi.13f4f8fd.jpg";